var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6602 0.989677C16.0202 -0.810322 12.7602 0.0296776 11.0002 2.08968C9.24021 0.0296776 5.98021 -0.820322 3.34021 0.989677C1.94021 1.94968 1.06021 3.56968 1.00021 5.27968C0.860213 9.15968 4.30021 12.2697 9.55021 17.0397L9.65021 17.1297C10.4102 17.8197 11.5802 17.8197 12.3402 17.1197L12.4502 17.0197C17.7002 12.2597 21.1302 9.14968 21.0002 5.26968C20.9402 3.56968 20.0602 1.94968 18.6602 0.989677ZM11.1002 15.5497L11.0002 15.6497L10.9002 15.5497C6.14021 11.2397 3.00021 8.38968 3.00021 5.49968C3.00021 3.49968 4.50021 1.99968 6.50021 1.99968C8.04021 1.99968 9.54021 2.98968 10.0702 4.35968H11.9402C12.4602 2.98968 13.9602 1.99968 15.5002 1.99968C17.5002 1.99968 19.0002 3.49968 19.0002 5.49968C19.0002 8.38968 15.8602 11.2397 11.1002 15.5497Z",
    fill: "#E35056"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.d7ed89c9.svg";
export { ForwardRef as ReactComponent };